"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropdownSelectedItem = void 0;
var css_1 = require("@emotion/css");
var react_1 = __importDefault(require("react"));
var shared_1 = require("../shared");
var design_system_foundations_1 = require("@contrast-security-inc/design-system-foundations");
var design_system_popovers_1 = require("@contrast-security-inc/design-system-popovers");
var useResizeObserver_1 = require("../utils/useResizeObserver");
/**
 * Bring the selection to the front so that the on-hover gets triggered,
 * keep the cursor looking like a button that will open/close the menu
 */
var customSelectedItemStyles = (0, css_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  z-index: 1;\n  cursor: pointer;\n  user-select: none;\n"], ["\n  z-index: 1;\n  cursor: pointer;\n  user-select: none;\n"])));
var customDisabledSelectedItemStyles = function (selectedTheme) { return (0, css_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  color: ", ";\n  cursor: not-allowed;\n"], ["\n  color: ", ";\n  cursor: not-allowed;\n"])), (0, design_system_foundations_1.getThemeValue)(selectedTheme, { light: design_system_foundations_1.theme.color.neutral60, dark: design_system_foundations_1.theme.color.neutral40 })); };
var DropdownSelectedItem = function (_a) {
    var itemToString = _a.itemToString, renderInputValue = _a.renderInputValue, testId = _a.testId, isOpen = _a.isOpen, isDisabled = _a.isDisabled, selectedItem = _a.selectedItem, showOverflowTooltip = _a.showOverflowTooltip, rest = __rest(_a, ["itemToString", "renderInputValue", "testId", "isOpen", "isDisabled", "selectedItem", "showOverflowTooltip"]);
    var selectedTheme = (0, design_system_foundations_1.useThemeContext)().selectedTheme;
    var _b = (0, useResizeObserver_1.useResizeObserver)(), observeRef = _b.observeRef, isOverflowing = _b.dimensions.isOverflowing;
    return showOverflowTooltip ? (react_1.default.createElement(design_system_popovers_1.Tooltip, { enabled: isOverflowing, ref: observeRef, isDelayed: true, body: itemToString(selectedItem), testId: "".concat(testId, "-selected-item-tooltip") },
        react_1.default.createElement("span", __assign({}, rest, { className: (0, css_1.cx)('ds-dropdown-input-value', (0, shared_1.selectedItemTextStyles)(false, selectedTheme), customSelectedItemStyles, isDisabled && customDisabledSelectedItemStyles(selectedTheme)), "data-testid": "".concat(testId, "-selected-item-input-value") }), renderInputValue ? renderInputValue(selectedItem, !!isOpen) : itemToString(selectedItem)))) : (react_1.default.createElement("span", __assign({}, rest, { className: (0, css_1.cx)('ds-dropdown-input-value', (0, shared_1.selectedItemTextStyles)(false, selectedTheme), isDisabled && customDisabledSelectedItemStyles(selectedTheme)), "data-testid": "".concat(testId, "-selected-item-input-value") }), renderInputValue ? renderInputValue(selectedItem, !!isOpen) : itemToString(selectedItem)));
};
exports.DropdownSelectedItem = DropdownSelectedItem;
var templateObject_1, templateObject_2;
